import { render } from "./ClientPanel.vue?vue&type=template&id=83a15d40&scoped=true"
import script from "./ClientPanel.vue?vue&type=script&lang=js"
export * from "./ClientPanel.vue?vue&type=script&lang=js"

import "./ClientPanel.vue?vue&type=style&index=0&id=83a15d40&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a15d40"]])

export default __exports__